<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof08">
<p class="tit"><em class="italic">Graduates of the Artillery and Engineer Cadet Corp/2nd Cadet Corps in 1762-1855</em><span class="font01"><sup><span href="#/therussian_endnotes#thent51" id="theft51" title="Link target outside of Sample">51</span></sup></span></p>
<p class="centerImage"><img alt="image" id="imgfr4" src="images/imgfr4.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof08.vue?c06681a6